<template>
  <form method="POST" class="form" @submit.prevent="onSubmit">
    <BaseText
      v-if="isComplete"
      v-html="'Спасибо! Ваше сообщение успешно отправлено :)'"
      is-block
    />
    <template v-else>
      <div class="form__field">
        <BaseField
          ref="field_name"
          type="text"
          label="Имя"
          placeholder="Денис Абрамов"
          :value="name"
          :error="nameError"
          required
          @input="update('name', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_position"
          type="text"
          label="Должность"
          placeholder="SMM-специалист"
          :value="position"
          :error="positionError"
          required
          @input="update('position', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_company"
          type="text"
          label="Компания"
          placeholder="ПАО «Норникель»"
          :value="company"
          :error="companyError"
          required
          @input="update('company', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_phone"
          type="text"
          label="Телефон"
          mask="tel"
          placeholder="+7 (529) 223-21-23"
          :value="phone"
          :error="phoneError"
          required
          @input="update('phone', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_email"
          type="email"
          label="E-mail"
          placeholder="abramov.denis@gmail.com"
          :value="email"
          :error="emailError"
          required
          @input="update('email', $event)"
        />
      </div>
      <div class="form__field">
        <BaseField
          ref="field_message"
          label="Сообщение"
          placeholder="Оцените курс"
          :value="message"
          :error="messageError"
          required
          @input="update('message', $event)"
        />
      </div>
      <div class="form__field">
        <BaseButton class="form__submit" type="submit" :disabled="isLoading" :is-loading="isLoading">
          Отправить
          <BaseIcon name="arrow" class="button__icon button__icon_after" />
        </BaseButton>
      </div>
    </template>
  </form>
</template>

<script>
import { mapActions } from 'vuex';

import BaseField from '@/components/BaseField.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'TheEvaluationForm',
  components: {
    BaseField,
    BaseButton,
    BaseIcon,
    BaseText,
  },
  data() {
    return {
      name: '',
      position: '',
      company: '',
      phone: '',
      email: '',
      message: '',
      nameError: '',
      positionError: '',
      companyError: '',
      phoneError: '',
      emailError: '',
      messageError: '',
      isLoading: false,
      isComplete: false,
    };
  },
  methods: {
    ...mapActions(['sendEvaluation']),
    update(name, value) {
      this[name] = value;
      this[`${name}Error`] = '';
    },
    onSubmit() {
      const isComplete = this.checkComplete();
      if (isComplete) {
        this.isLoading = true;
        this.sendEvaluation({
          name: this.name,
          position: this.position,
          company: this.company,
          phone: this.phone,
          email: this.email,
          message: this.message,
        })
          .catch(console.error)
          .then(this.setComplete)
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    setComplete() {
      this.name = '';
      this.position = '';
      this.company = '';
      this.phone = '';
      this.email = '';
      this.message = '';
      this.nameError = '';
      this.positionError = '';
      this.companyError = '';
      this.phoneError = '';
      this.emailError = '';
      this.messageError = '';
      this.isComplete = true;
    },
    checkComplete() {
      if (!this.$refs.field_name.checkComplete()) {
        this.nameError = 'Давайте знакомиться, как вас зовут?';
        this.$refs.field_name.setFocus();
        return false;
      }
      if (!this.$refs.field_position.checkComplete()) {
        this.positionError = 'Расскажите кем вы работаете';
        this.$refs.field_position.setFocus();
        return false;
      }
      if (!this.$refs.field_company.checkComplete()) {
        this.companyError = 'Расскажите где вы работаете';
        this.$refs.field_company.setFocus();
        return false;
      }
      if (!this.$refs.field_phone.checkComplete()) {
        this.phoneError = 'Необходимо указать свой телефон';
        this.$refs.field_phone.setFocus();
        return false;
      }
      if (!this.$refs.field_email.checkComplete()) {
        this.emailError = 'Необходимо указать свой E-mail';
        this.$refs.field_email.setFocus();
        return false;
      }
      if (!this.$refs.field_message.checkComplete()) {
        this.messageError = 'Неужели вы ничего не напишете?';
        this.$refs.field_message.setFocus();
        return false;
      }
      return true;
    },
  },
};
</script>
